const ZENDESK_KEY = '62ffb7cb-df06-4fd2-b0dc-4d1b9d9a5875';

export const ZENDESK = {
  ID: 'ze-snippet',
  URL: `https://static.zdassets.com/ekr/snippet.js?key=${ZENDESK_KEY}`,
};
